import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ChatBotService from "../../services/chatbot.service";

/* ================= THUNKS ================= */

export const sendChatMessage = createAsyncThunk(
  "chatbot/sendMessage",
  async (payload, thunkAPI) => {
    try {
      const response = await ChatBotService.sendMessage(payload);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data || {
          success: false,
          message: err.message,
        }
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,

  response: null,
  responseSource: null,
  confidence: null,

  updateSuccess: false,
};

const chatbotSlice = createSlice({
  name: "chatbot",
  initialState,
  reducers: {
    resetChatbot(state) {
      state.response = null;
      state.responseSource = null;
      state.confidence = null;
      state.error = null;
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(sendChatMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(sendChatMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        state.response = action.payload;
        state.responseSource = action.payload.responseSource || null;
        state.confidence = action.payload.confidence || null;
      })

      .addCase(sendChatMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetChatbot } = chatbotSlice.actions;

export default chatbotSlice.reducer;